import React, { useMemo } from 'react';
import { taskListReducer } from './reducer';


export const initialState = JSON.parse(localStorage.getItem('taskList')) || {
  taskList: [
    {
      title: 'learn react', 
      description:'learn basic react and implement context API', 
      startTime: '11:00 AM',
      endTime: '02:30 PM',
      isActive: true,
      isCompleted: false,
      isArchived: false,
      show:true
    },{
      title: 'learn next.js', 
      description:'learn basic next.js and implement its core feature', 
      startTime: '11:00 AM',
      endTime: '02:30 PM',
      isActive: true,
      isCompleted: false,
      isArchived: false,
      show:true
    },{
      title: 'learn micro-frontend', 
      description:'learn micro-frontend and implement its core feature', 
      startTime: '11:00 AM',
      endTime: '02:30 PM',
      isActive: true,
      isCompleted: false,
      isArchived: false,
      show:true
    },{
      title: 'learn Graphql', 
      description:'learn basic Graphql and implement its core feature', 
      startTime: '11:00 AM',
      endTime: '02:30 PM',
      isActive: true,
      isCompleted: false,
      isArchived: false,
      show:true
    }
  ]
};

const AppContext = React.createContext(initialState);

const AppContextProvider = ({ children }) => {
  const [state, dispatch] = React.useReducer(taskListReducer, {
    ...initialState
  });

  const value = useMemo(
    () => ({ state, dispatch }),
    [state, dispatch],
  );

  return <AppContext.Provider value={value}>{children}</AppContext.Provider>;
};

export {AppContext, AppContextProvider}
